
export default function ExperienceSection() {
  const experiences = [
    {
      company: 'Companhia do Aço',
      position: 'Analista PPCP JR',
      period: '2025 — Atual',
      description: 'Responsável pelo planejamento e controle da produção, implementação de melhorias contínuas e otimização de processos industriais.',
      achievements: ['Redução de 15% no tempo de setup', 'Implementação de indicadores OEE', 'Melhoria na produtividade da linha'],
      current: true
    },
    {
      company: 'NEVAN',
      position: 'Analista PPCP',
      period: '2024',
      description: 'Desenvolvimento de sistemas de controle de produção e implementação de metodologias de planejamento estratégico.',
      achievements: ['Criação de cronogramas mestres', 'Balanceamento de linhas produtivas', 'Redução de desperdícios'],
      current: false
    },
    {
      company: 'Copacol',
      position: 'Operadora de Máquinas / Auxiliar de Produção',
      period: '2023 — 2024',
      description: 'Operação de equipamentos industriais e suporte na linha de produção, desenvolvendo conhecimento prático dos processos.',
      achievements: ['Operação segura de equipamentos', 'Melhoria de processos', 'Zero acidentes'],
      current: false
    },
    {
      company: 'SENAI PR',
      position: 'Professora',
      period: '2022',
      description: 'Docência em cursos técnicos de engenharia e segurança do trabalho, desenvolvendo conteúdos e metodologias de ensino.',
      achievements: ['Desenvolvimento de conteúdo técnico', 'Formação de profissionais', 'Avaliação de 95% de aprovação'],
      current: false
    },
    {
      company: 'Alfa Arquitetura e Engenharia',
      position: 'Engenheira Civil',
      period: '2022',
      description: 'Desenvolvimento de projetos estruturais e acompanhamento de obras, com foco em conformidade e qualidade.',
      achievements: ['Projetos estruturais aprovados', 'Acompanhamento de obras', 'Laudos técnicos'],
      current: false
    }
  ];

  return (
    <section id="experiencia" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold mb-6 text-gray-900">
            Minha <span className="text-yellow-600">Experiência</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Trajetória profissional consolidada em engenharia civil, PPCP e segurança do trabalho.
          </p>
        </div>

        <div className="relative">
          {/* Timeline line */}
          <div className="absolute left-4 md:left-1/2 transform md:-translate-x-1/2 top-0 bottom-0 w-0.5 bg-yellow-200"></div>

          <div className="space-y-12">
            {experiences.map((exp, index) => (
              <div key={index} className={`relative flex items-center ${
                index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
              } flex-col md:flex-row`}>
                {/* Timeline dot */}
                <div className={`absolute left-4 md:left-1/2 transform md:-translate-x-1/2 ${
                  exp.current ? 'bg-yellow-500' : 'bg-gray-300'
                } w-4 h-4 rounded-full border-4 border-white shadow-lg z-10`}></div>

                {/* Content card */}
                <div className={`w-full md:w-5/12 ${
                  index % 2 === 0 ? 'md:pr-8 pl-12 md:pl-0' : 'md:pl-8 pl-12 md:pl-0'
                }`}>
                  <div className={`bg-gray-50 rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow ${
                    exp.current ? 'ring-2 ring-yellow-500' : ''
                  }`}>
                    <div className="flex items-center justify-between mb-4">
                      <span className={`px-3 py-1 rounded-full text-sm font-medium ${
                        exp.current 
                          ? 'bg-yellow-100 text-yellow-800' 
                          : 'bg-gray-100 text-gray-600'
                      }`}>
                        {exp.period}
                      </span>
                      {exp.current && (
                        <span className="bg-green-100 text-green-800 px-2 py-1 rounded-full text-xs font-medium">
                          Atual
                        </span>
                      )}
                    </div>
                    
                    <h3 className="text-xl font-bold text-gray-900 mb-2">{exp.position}</h3>
                    <h4 className="text-yellow-600 font-semibold mb-4">{exp.company}</h4>
                    
                    <p className="text-gray-700 mb-6 leading-relaxed">{exp.description}</p>
                    
                    <div>
                      <h5 className="font-semibold text-gray-900 mb-3">Principais Conquistas:</h5>
                      <ul className="space-y-2">
                        {exp.achievements.map((achievement, idx) => (
                          <li key={idx} className="flex items-start gap-2">
                            <i className="ri-arrow-right-s-line text-yellow-600 mt-0.5 flex-shrink-0"></i>
                            <span className="text-gray-600 text-sm">{achievement}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>

                {/* Spacer for timeline */}
                <div className="hidden md:block w-2/12"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
